module.exports = __webpack_public_path__ + "img/type_icon1.52302f3b.png";